import useMedia from '~hooks/useMedia';

import { S } from './style';

function CompanyHeaderSkeleton() {
  const { isMobile } = useMedia();

  return (
    <S.Warpper>
      <S.Logo />
      <S.Content>
        <S.Name />
        <S.Info />
        {isMobile && <S.Info />}
      </S.Content>
      <S.ButtonGroup>
        <button />
        <button />
      </S.ButtonGroup>
    </S.Warpper>
  );
}
export default CompanyHeaderSkeleton;
